import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE } from '../../lib/apiOrigin';
import { useAdminLanguage } from '../../i18n/adminTranslations';
import JobMarketplacePanel from './JobMarketplacePanel';

export default function JobDispatchTab({ token, initialLeadId = '' }) {
  const { lang, a } = useAdminLanguage();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [revision, setRevision] = useState(0);
  const refresh = useCallback(() => setRevision(value => value + 1), []);
  useEffect(() => {
    let active = true;
    setError(false); setData(null);
    const config = { headers: { 'X-Admin-Token': token }, timeout: 15000 };
    Promise.all([
      axios.get(`${API_BASE}/admin/leads/summary`, config),
      axios.get(`${API_BASE}/admin/installers`, config),
    ]).then(([jobs, people]) => {
      if (!active) return;
      const leads = Array.isArray(jobs.data) ? jobs.data : jobs.data?.leads;
      const installers = Array.isArray(people.data) ? people.data : people.data?.installers;
      if (!Array.isArray(leads) || !Array.isArray(installers)) throw new Error('Invalid dispatch data');
      setData({ leads, installers });
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [token, revision]);
  return <section className="space-y-5" data-testid="job-dispatch-tab">
    <h2 className="font-display text-3xl font-bold">{a('Distribute jobs')}</h2>
    <p>{a('Review each job first. Assign it to Xavier or an approved Pro, or release it to available Pros. Opening this screen does not assign or release a job.')}</p>
    {error ? <div role="alert"><p>{a('Unable to load jobs and Pros. Try again.')}</p><button type="button" className="btn-secondary mt-3" onClick={refresh}>{a('Refresh')}</button></div> : !data ? <p role="status">{a('Loading…')}</p> :
      <JobMarketplacePanel token={token} leads={data.leads} installers={data.installers} lang={lang} initialLeadId={initialLeadId} onUpdated={refresh} />}
  </section>;
}
